import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "pause",
  "use": "pause-usage",
  "viewBox": "0 0 18 20",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 18 20\" id=\"pause\">\n    <rect width=\"6\" height=\"20\" rx=\"1\" />\n    <rect width=\"6\" height=\"20\" x=\"12\" rx=\"1\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol